import { environment } from '@environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class AnalysisStatusService {
    // eslint-disable-next-line
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    setStatusCompleted(analysisId) {
        return this.httpClient.patch(environment.api.base + 'efas/' + analysisId + '/complete', null);
    }
}
AnalysisStatusService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AnalysisStatusService_Factory() { return new AnalysisStatusService(i0.ɵɵinject(i1.HttpClient)); }, token: AnalysisStatusService, providedIn: "root" });
